import React from "react";
import { Formik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { environment } from "../../environnements/ennvironnement";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";

const checkoutSchema = yup.object().shape({
    email: yup.string().required("Email is required"),
    password: yup.string().required("Password is required"),
});

function Signin() {
    const history = useHistory();
    const { signIn } = useAuth();
    
    const initialValues = {
        email: "",
        password: ""
    }

    const handleSignIn = async (req) => {
        try {
            const response = await axios.post(`${environment.backend_url}/ws/api/v1/accounts/login/`, {
                email: req.email,
                password: req.password
            });

            if (response.data[0].success === 1) {
                const userData = {
                    ...response.data[0].results[0],
                    access: response.data[0].results[0].access_token,
                    refresh: response.data[0].results[0].refresh_token
                };
                
                await signIn(userData);
                toast.success('Successfully logged in!');
                history.push('/dashboard');
            } else {
                toast.error("Login failed");
            }
        } catch (error) {
            if (error.response) {
                const errorMessage = error.response.data?.errors?.[0]?.error_msg || "Invalid credentials";
                toast.error(errorMessage);
            } else if (error.request) {
                toast.error("Unable to reach server");
            } else {
                toast.error("An error occurred");
            }
        }
    }

    return (
        <>
            <div className="authincation section-padding">
                <div className="container h-100">
                    <div className="row justify-content-center h-100 align-items-center">
                        <div className="col-xl-5 col-md-6">
                            <div className="mini-logo text-center my-5">
                                <Link className="d-flex justify-content-center align-items-center" to={"./"}>
                                    <img
                                        src={require("../../assets/img/logo.png")}
                                        alt="logo"
                                        width="50px"
                                    />
                                    <h1 className="toolbar-title">Zedon Pro</h1>
                                </Link>
                            </div>
                            <div className="auth-form card">
                                <div className="card-header justify-content-center">
                                    <h4 className="card-title">Sign in</h4>
                                </div>
                                <div className="card-body">

            <Formik
                onSubmit={handleSignIn}
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={checkoutSchema}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleBlur,
                      handleChange,
                      handleSubmit,
                      setFieldValue,
                  }) => (
                                    <form
                                        method="post"
                                        name="myform"
                                        className="signin_validate"
                                        onSubmit={handleSubmit}
                                    >
                                        <div className="mb-3">
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="hello@example.com"
                                                name="email"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.email}
                                            />
                                            {errors.email && touched.email && (
                                                <div className="text-danger">{errors.email}</div>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <label>Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                placeholder="Password"
                                                name="password"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.password}
                                            />
                                            {errors.password && touched.password && (
                                                <div className="text-danger">{errors.password}</div>
                                            )}
                                        </div>
                                        <div className="row d-flex justify-content-between mt-4 mb-2">
                                            <div className="mb-3 mb-0">
                                                <label className="toggle">
                                                    <input
                                                        className="toggle-checkbox"
                                                        type="checkbox"
                                                    />
                                                    <span className="toggle-switch"></span>
                                                    <span className="toggle-label">
                                                        Remember me
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="mb-3 mb-0">
                                                <Link to={"./reset"}>
                                                    Forgot Password?
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <button
                                            type="submit"
                                                //onClick={handleSignIn}
                                                className="btn btn-success btn-block"
                                            >
                                                Sign in
                                            </button>
                                        </div>
                                    </form>)}
                                    </Formik>
                                    <div className="new-account mt-3">
                                        <p>
                                            Don't have an account?{" "}
                                            <Link
                                                className="text-primary"
                                                to={"./signup"}
                                            >
                                                Sign up
                                            </Link>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Signin;
